import { render, staticRenderFns } from "./TabAddNewUsers.vue?vue&type=template&id=2007e35a&scoped=true&"
import script from "./TabAddNewUsers.vue?vue&type=script&lang=js&"
export * from "./TabAddNewUsers.vue?vue&type=script&lang=js&"
import style0 from "./TabAddNewUsers.vue?vue&type=style&index=0&id=2007e35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007e35a",
  null
  
)

export default component.exports